<template>
  <div class="help-panel" v-loading="helpStore.loading">
    <div class="help-header">
      <el-icon><QuestionFilled /></el-icon>
      <h3>{{ t('common.help') }}</h3>
    </div>
    <div class="help-content">
      <div v-if="helpStore.helpContent" v-html="helpStore.helpContent"></div>
      <el-empty v-else :description="t('common.noHelp')" :image-size="100" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { watch } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useHelpStore } from '../stores/help'
import { QuestionFilled } from '@element-plus/icons-vue'

const route = useRoute()
const helpStore = useHelpStore()
const { t, locale } = useI18n()

watch(
  () => [route.path, locale.value],
  () => {
    const key = (route.meta.helpKey as string) || ''
    if (key) {
      helpStore.fetchHelp(key)
    } else {
      helpStore.helpContent = ''
    }
  },
  { immediate: true }
)
</script>

<style scoped>
.help-panel {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.help-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--el-border-color-light);
}
.help-header h3 {
  margin: 0;
  font-size: 16px;
  color: var(--el-text-color-primary);
}
.help-content {
  flex: 1;
  overflow-y: auto;
  font-size: 14px;
  line-height: 1.8;
  color: var(--el-text-color-regular);
}
.help-content :deep(h4) {
  color: var(--el-text-color-primary);
  margin: 12px 0 8px;
}
.help-content :deep(h5) {
  color: var(--el-text-color-primary);
  margin: 8px 0 6px;
}
</style>
